import { useLang } from "../../i18n/LanguageContext";
import { Reveal, Overline } from "./Reveal";

export const Market = () => {
  const { t } = useLang();
  const m = t.market;

  return (
    <section id="market" className="bg-white border-b border-border" data-testid="market">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <Reveal>
              <Overline index="06">{m.label}</Overline>
              <h2 className="font-heading text-4xl sm:text-5xl font-medium tracking-tight text-nero-ink leading-[1.05]">
                {m.title}
              </h2>
              <p className="mt-6 font-body text-lg leading-relaxed text-zinc-600">{m.text}</p>
            </Reveal>
          </div>

          <div className="lg:col-span-6 lg:col-start-7">
            <Reveal delay={0.1}>
              <div className="border-t border-border">
                <div className="font-body text-xs uppercase tracking-[0.22em] font-semibold text-zinc-500 py-5">
                  {m.driversTitle}
                </div>
                {m.drivers.map((d, i) => (
                  <div
                    key={i}
                    className="group flex items-center gap-6 border-t border-border py-6 hover:px-2 transition-all duration-300"
                    data-testid={`market-driver-${i}`}
                  >
                    <span className="font-heading text-sm font-bold text-nero-green w-8 tabular-nums">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="font-heading text-2xl sm:text-3xl font-medium tracking-tight text-nero-ink group-hover:text-nero-green transition-colors">
                      {d}
                    </span>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
